export const ViewAction = Object.freeze({
  CREATE: "create",
  EDIT: "edit",
  AdminEdit: "adminEdit",
});
